export const state = {
  competence: undefined,
  competences: [],
  communes: [],
  sousCompetence: undefined,
  sousCompetences: []
}